export function normalizeEnglish(value: string): string {
  return value.normalize('NFKC').toLocaleLowerCase('en-US');
}
